export default __webpack_public_path__ + "static/media/Formation2.21b5bc00.png";